import React, { useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { NavLink } from "react-router-dom";
import { FaRegPaperPlane } from "react-icons/fa";
import { UserContext } from "../context/UserContext";

const Navbar = () => {
  const { state } = useContext(UserContext);
  useEffect(() => {
    // Add event listener to the document's click event
    document.addEventListener("click", handleDocumentClick);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  // Function to handle clicks on the document
  const handleDocumentClick = (e) => {
    const navbar = document.querySelector(".navbar-collapse.show");

    // Check if the click target is outside of the navbar and the navbar is expanded
    if (navbar && !navbar.contains(e.target)) {
      // Collapse the navbar
      const toggleButton = document.querySelector(".navbar-toggler");
      if (toggleButton) {
        toggleButton.click();
      }
    }
  };

  return (
    <nav
      className="navbar navbar-expand-lg bg-body-tertiary"
      style={{ top: "0", position: "sticky", zIndex: 1000 }}
    >
      <div className="container-fluid">
        <NavLink className="navbar-brand nav-logo fs-4" to="/">
          <FaRegPaperPlane className="mx-1" />
          Blogify
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                className="nav-link active"
                aria-current="page"
                to="/articles"
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/articles/new">
                Create
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/category/Tech">
                Category
              </NavLink>
            </li>
            {!state ? (
              <li className="nav-item">
                <NavLink className="nav-link" to="/login">
                  Login
                </NavLink>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/profile">
                    Profile
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/logout">
                    Logout
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
